module.exports = __webpack_public_path__ + "img/fish-icon.a2845603.svg";